import { type ThemeOptions, type Theme } from '@mui/material';

export function createMenuStyles() {
  return {
    MuiMenu: {
      styleOverrides: {
        paper: ({ theme }: { theme: Theme }) => ({
          variants: [
            {
              props: (props) => !props['square'],
              style: {
                borderRadius: `${theme.shape.borderRadiusMd}px`,
              },
            },
          ],
        }),
      },
    },
    MuiMenuItem: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-focusVisible': {
            '&::after': {
              borderRadius: `${theme.ui.focus.borderRadius}`,
              content: '""',
              inset: 4,
              outline: `${theme.ui.focus.outlineWidth} solid ${theme.palette.action.focusOutline}`,
              outlineOffset: `${theme.ui.focus.outlineOffset}`,
              position: 'absolute',
            },
            background: 'none',
          },
        }),
      },
    },
  } as ThemeOptions['components'];
}
